import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useTheme } from "../../../contexts/ThemeContext";
import { useAuth } from "../../../contexts/AuthContext";
import LayoutDesktop from "../../../layouts/LayoutDesktop";

import { db } from "../../../config/firebase";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  updateDoc,
  where,
} from "firebase/firestore";

function EditarStatus() {
  const { tema } = useTheme();
  const { usuario: usuarioLogado } = useAuth();
  const navigate = useNavigate();
  const { id } = useParams(); // id do status

  const [empresas, setEmpresas] = useState([]);

  const [carregandoEmpresas, setCarregandoEmpresas] = useState(false);
  const [carregandoStatus, setCarregandoStatus] = useState(true);

  const [nome, setNome] = useState("");
  const [empresaId, setEmpresaId] = useState("");
  const [cor, setCor] = useState("#000000");
  const [observacoes, setObservacoes] = useState("");

  const [padrao, setPadrao] = useState(false);

  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState("");

  useEffect(() => {
    async function carregarEmpresas() {
      if (!usuarioLogado?.grupoId) return;

      try {
        setCarregandoEmpresas(true);
        const empresasRef = collection(db, "empresas");
        const qEmp = query(
          empresasRef,
          where("grupoId", "==", usuarioLogado.grupoId)
        );
        const snapEmp = await getDocs(qEmp);
        const listaEmp = snapEmp.docs.map((docSnap) => ({
          id: docSnap.id,
          ...docSnap.data(),
        }));
        setEmpresas(listaEmp);
      } catch (e) {
        console.error("Erro ao carregar empresas:", e);
        setErro("Erro ao carregar empresas. Verifique o cadastro do grupo.");
      } finally {
        setCarregandoEmpresas(false);
      }
    }

    carregarEmpresas();
  }, [usuarioLogado]);

  useEffect(() => {
    async function carregarStatus() {
      if (!id) return;

      try {
        setCarregandoStatus(true);
        const ref = doc(db, "statusOs", id);
        const snap = await getDoc(ref);

        if (!snap.exists()) {
          setErro("Status não encontrado.");
          setCarregandoStatus(false);
          return;
        }

        const dados = snap.data();

        setNome(dados.nome || "");
        setEmpresaId(dados.empresaId || "");
        setCor(dados.cor || "#000000");
        setObservacoes(dados.observacoes || "");
        setPadrao(!!dados.padrao);
      } catch (e) {
        console.error(e);
        setErro("Erro ao carregar status.");
      } finally {
        setCarregandoStatus(false);
      }
    }

    carregarStatus();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro("");
    setSucesso("");

    if (padrao) {
      setErro("Status padrão do sistema não pode ser editado.");
      return;
    }

    if (!nome.trim()) {
      setErro("Informe o nome do status.");
      return;
    }

    if (!empresaId) {
      setErro("Selecione a empresa.");
      return;
    }

    const empresaSelecionada = empresas.find((e) => e.id === empresaId);
    const empresaNome = empresaSelecionada?.nome || null;

    try {
      setSalvando(true);

      const ref = doc(db, "statusOs", id);
      await updateDoc(ref, {
        grupoId: usuarioLogado?.grupoId || null,
        grupoNome: usuarioLogado?.grupoNome || usuarioLogado?.grupo || null,
        nome: nome.trim(),
        empresaId,
        empresaNome,
        cor: cor || "#000000",
        observacoes: observacoes.trim() || null,
        updatedAt: new Date(),
      });

      setSucesso("Status atualizado com sucesso!");
    } catch (e) {
      console.error(e);
      setErro("Erro ao salvar alterações.");
    } finally {
      setSalvando(false);
    }
  };

  if (carregandoStatus) {
    return (
      <LayoutDesktop tema={tema} titulo="Editar Status" subtitulo="">
        <p>Carregando dados do status...</p>
      </LayoutDesktop>
    );
  }

  const camposDesabilitados = padrao;

  return (
    <LayoutDesktop
      tema={tema}
      titulo="Editar Status"
      subtitulo={nome ? `Ajuste de dados do status ${nome}` : ""}
    >
      <section className="pc-card">
        <h2 style={{ marginTop: 0 }}>Dados do status</h2>

        {padrao && (
          <div
            style={{
              marginTop: 12,
              padding: 8,
              borderRadius: 8,
              background: "#0f172a",
              color: "#e5e7eb",
              fontSize: 14,
            }}
          >
            Este status é <strong>padrão do sistema</strong> e não pode ser
            alterado nem excluído.
          </div>
        )}

        {erro && (
          <div
            style={{
              marginTop: 12,
              padding: 8,
              borderRadius: 8,
              background: "#7f1d1d",
              color: "#fecaca",
              fontSize: 14,
            }}
          >
            {erro}
          </div>
        )}

        {sucesso && (
          <div
            style={{
              marginTop: 12,
              padding: 8,
              borderRadius: 8,
              background: "#14532d",
              color: "#bbf7d0",
              fontSize: 14,
            }}
          >
            {sucesso}
          </div>
        )}

        <form
          onSubmit={handleSubmit}
          style={{
            marginTop: 12,
            maxWidth: 720,
            marginLeft: "auto",
            marginRight: "auto",
            display: "flex",
            flexDirection: "column",
            gap: 12,
          }}
        >
          {/* Nome */}
          <label>
            <span style={{ fontSize: 14 }}>Nome</span>
            <input
              type="text"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              disabled={camposDesabilitados}
              style={{
                width: "100%",
                padding: "9px 11px",
                marginTop: 4,
                borderRadius: 8,
                border: "1px solid #334155",
                
              }}
            />
          </label>

          {/* Empresa */}
          <label>
            <span style={{ fontSize: 14 }}>Empresa</span>
            <select
              value={empresaId}
              onChange={(e) => setEmpresaId(e.target.value)}
              disabled={carregandoEmpresas || camposDesabilitados}
              style={{
                width: "100%",
                padding: "9px 11px",
                marginTop: 4,
                borderRadius: 8,
                border: "1px solid #334155",
                
                color: "inherit",
              }}
            >
              <option value="">
                {carregandoEmpresas
                  ? "Carregando empresas..."
                  : "Selecione a empresa"}
              </option>
              {empresas.map((emp) => (
                <option key={emp.id} value={emp.id}>
                  {emp.nome || "(sem nome)"}
                </option>
              ))}
            </select>
          </label>

          {/* Cor */}
          <label>
            <span style={{ fontSize: 14 }}>Cor</span>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                marginTop: 4,
              }}
            >
              <input
                type="color"
                value={cor}
                onChange={(e) => setCor(e.target.value)}
                disabled={camposDesabilitados}
                style={{
                  width: 48,
                  height: 32,
                  padding: 0,
                  borderRadius: 8,
                  border: "1px solid #334155",
                  
                }}
              />
              <input
                type="text"
                value={cor}
                onChange={(e) => setCor(e.target.value)}
                disabled={camposDesabilitados}
                style={{
                  flex: 1,
                  padding: "9px 11px",
                  borderRadius: 8,
                  border: "1px solid #334155",
                  
                  fontFamily: "monospace",
                }}
              />
            </div>
          </label>

          {/* Observações */}
          <label>
            <span style={{ fontSize: 14 }}>Observações</span>
            <textarea
              value={observacoes}
              onChange={(e) => setObservacoes(e.target.value)}
              disabled={camposDesabilitados}
              rows={3}
              style={{
                width: "100%",
                padding: "9px 11px",
                marginTop: 4,
                borderRadius: 8,
                border: "1px solid #334155",
                
                resize: "vertical",
              }}
            />
          </label>

          <div
            style={{
              marginTop: 14,
              display: "flex",
              gap: 10,
              justifyContent: "flex-end",
            }}
          >
            <button
              type="button"
              onClick={() => navigate("/cadastros/status")}
              className="pc-btn-secundario"
            >
              Voltar
            </button>
            <button
              type="submit"
              className="pc-btn-primario"
              disabled={salvando || camposDesabilitados}
            >
              {salvando ? "Salvando..." : "Salvar alterações"}
            </button>
          </div>
        </form>
      </section>
    </LayoutDesktop>
  );
}

export default EditarStatus;
